import React, { Component, Fragment } from 'react';
// eslint-disable-next-line import/no-extraneous-dependencies
import { hot, setConfig } from 'react-hot-loader';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.css';
import '../../scss/app.scss';
import Router from './Router';
import store from '../../redux/store';
import ScrollToTop from './ScrollToTop';
import { setLoading } from '../../redux/actions/paramsActions';
import firebaseAuth from '../../utils/firebase';
import { setUser } from '../../redux/actions/userActions';
import callDb from '../../utils/server';

setConfig({
  showReactDomPatchNotification: false,
});

class App extends Component {
  constructor() {
    super();
    this.state = {
      authed: false,
      loading: true,
      // emailVerified: false,
      // email: '',
    };
  }

  componentWillMount() {
    const { dispatch } = store;
    this.removeListener = firebaseAuth().onAuthStateChanged((user) => {
      if (user) {
        console.log('user is indeed auth: ', user);
        this.setState({
          authed: true,
          loading: false,
          // emailVerified: true,
          // email: user.email,
        });
        this.fetchAllInfo();
      } else {
        console.log('user is not AUTHENTICATED');
        this.setState({
          authed: false,
          loading: false,
          // emailVerified: false,
        });
        dispatch(setLoading(false));
      }
    });
  }

  componentWillUnmount() {
    this.removeListener();
  }

  /* eslint-disable class-methods-use-this */
  fetchAllInfo() {
    const { dispatch } = store;
    callDb({}, 'users/fetchAllInfo').then((result) => {
      const { data } = result;
      dispatch(setUser(data.userInfo));
      dispatch(setLoading(false));
      console.log('returned all Info is: ', data);
    }).catch((err) => {
      console.log(err);
    });
  }

  render() {
    const {
      loading, authed,
    } = this.state;
    return (
      <Provider store={store}>
        <BrowserRouter>
          <ScrollToTop>
            <Fragment>
              {loading
              && (
              <div className={`load${loading ? '' : ' loaded'}`}>
                <div className="load__icon-wrap">
                  <svg className="load__icon">
                    <path fill="#4EA7FF" d="M12,4V2A10,10 0 0,0 2,12H4A8,8 0 0,1 12,4Z" />
                  </svg>
                </div>
              </div>
              )
              }
              <Router authed={authed} />
            </Fragment>
          </ScrollToTop>
        </BrowserRouter>
      </Provider>
    );
  }
}

export default hot(module)(App);
